"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("customerCommunications").controller("CustomerCommunicationsCtrl", CustomerCommunicationsCtrl);

  function CustomerCommunicationsCtrl($rootScope, $scope, $timeout, $controller, moment, AgGridService, CustomListsService, CustomerCommunicationsService, CustomersService, ElearningCampaignsService, ElearningTemplatesService, APP_URL, ApiService) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "CustomerCommunicationsCtrl";

    vm.log = debug("pages:customerCommunications");

    vm.tutoIsActived = true;

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: CustomerCommunicationsService,
      params: {
        editPage: "customerCommunications/customerCommunication"
      }
    });

    vm.gridEvent = function (value) {
      if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 1;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Communications"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.openVideoLink = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var links, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, templateId, mobileModel, result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, link;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                links = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = row.elearningTemplateIds[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 22;
                  break;
                }

                templateId = _step.value;
                _context.prev = 8;
                mobileModel = ApiService.getModel("mobile", [], function () {
                  return "";
                });
                _context.next = 12;
                return mobileModel.customPost("video/" + templateId + "/tempLink", {});

              case 12:
                result = _context.sent;

                links.push(APP_URL + "?tempId=" + result.tempId);
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](8);

                Notiflix.Notify.failure("Impossible de générer le lien vidéo");

              case 19:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t1 = _context["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 28:
                _context.prev = 28;
                _context.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context.prev = 31;

                if (!_didIteratorError) {
                  _context.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context.finish(31);

              case 35:
                return _context.finish(28);

              case 36:
                if (!(!links || links.length === 0)) {
                  _context.next = 39;
                  break;
                }

                Notiflix.Notify.failure("Aucun lien vidéo portrait n'est disponible pour cette campagne.");
                return _context.abrupt("return");

              case 39:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 42;

                for (_iterator2 = links[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  link = _step2.value;

                  window.open(link, "_blank");
                }
                _context.next = 50;
                break;

              case 46:
                _context.prev = 46;
                _context.t2 = _context["catch"](42);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t2;

              case 50:
                _context.prev = 50;
                _context.prev = 51;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 53:
                _context.prev = 53;

                if (!_didIteratorError2) {
                  _context.next = 56;
                  break;
                }

                throw _iteratorError2;

              case 56:
                return _context.finish(53);

              case 57:
                return _context.finish(50);

              case 58:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 24, 28, 36], [8, 16], [29,, 31, 35], [42, 46, 50, 58], [51,, 53, 57]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.openPortraitLink = function (row) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = row.portraitPosterLinks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var link = _step3.value;

          window.open(link, "_blank");
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    };

    vm.openLandscapeLink = function (row) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = row.landscapePosterLinks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var link = _step4.value;

          window.open(link, "_blank");
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    };

    vm.refresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var where, customerCommunications, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, customerCommunication, keywordsNames, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, keyword, keywordName, customer, campaigns, rowTypeShort, rowTypeChallenge, rowWay, templates, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, campaign, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _loop, _iterator8, _step8, row;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context3.prev = 1;

                vm.log("refresh customerCommunications", params);

                if (params && params.from && params.to) {
                  vm.from = params.from;
                  vm.to = params.to;
                }

                if (!vm.from || !vm.to) {
                  vm.from = moment().subtract(12, "months").startOf("month").toDate();
                  vm.to = moment().endOf("month").toDate();
                }

                where = { communicationDate: { $gte: vm.from, $lte: vm.to } };
                _context3.next = 8;
                return CustomerCommunicationsService.load(null, false, null, where);

              case 8:
                customerCommunications = _context3.sent;


                vm.rawData = [];

                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context3.prev = 13;
                _iterator5 = customerCommunications[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context3.next = 73;
                  break;
                }

                customerCommunication = _step5.value;

                customerCommunication.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                customerCommunication.btDelete = {
                  text: '<i class="fa fa-trash"></i> Suppr.',
                  color: "custom-danger"
                };
                _context3.prev = 19;
                _context3.next = 22;
                return CustomersService.getNameById(customerCommunication.customerId);

              case 22:
                customerCommunication.customerName = _context3.sent;


                customerCommunication.nbDocs = customerCommunication.docs ? customerCommunication.docs.length : 0;

                _context3.next = 26;
                return CustomListsService.getNameByValue("typeCustomerCommunication", customerCommunication.communicationType);

              case 26:
                customerCommunication.typeName = _context3.sent;
                _context3.next = 29;
                return CustomListsService.getNameByValue("typeCommunicationWay", customerCommunication.communicationWay);

              case 29:
                customerCommunication.wayName = _context3.sent;
                keywordsNames = [];

                if (!customerCommunication.keywords) {
                  _context3.next = 60;
                  break;
                }

                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context3.prev = 35;
                _iterator7 = customerCommunication.keywords[Symbol.iterator]();

              case 37:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context3.next = 46;
                  break;
                }

                keyword = _step7.value;
                _context3.next = 41;
                return CustomListsService.getNameByValue("keywords", keyword);

              case 41:
                keywordName = _context3.sent;

                keywordsNames.push("#" + keywordName);

              case 43:
                _iteratorNormalCompletion7 = true;
                _context3.next = 37;
                break;

              case 46:
                _context3.next = 52;
                break;

              case 48:
                _context3.prev = 48;
                _context3.t0 = _context3["catch"](35);
                _didIteratorError7 = true;
                _iteratorError7 = _context3.t0;

              case 52:
                _context3.prev = 52;
                _context3.prev = 53;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 55:
                _context3.prev = 55;

                if (!_didIteratorError7) {
                  _context3.next = 58;
                  break;
                }

                throw _iteratorError7;

              case 58:
                return _context3.finish(55);

              case 59:
                return _context3.finish(52);

              case 60:
                customerCommunication.keywordsNames = keywordsNames;

                customerCommunication.links = customerCommunication.docs && customerCommunication.docs.length ? customerCommunication.docs.map(function (doc) {
                  return doc.url;
                }) : [];
                customerCommunication.btOpenLink = customerCommunication.docs && customerCommunication.docs.length ? {
                  text: '<i class="fa fa-download"></i> Télécharger',
                  color: "custom"
                } : null;

                vm.rawData.push(customerCommunication);
                _context3.next = 70;
                break;

              case 66:
                _context3.prev = 66;
                _context3.t1 = _context3["catch"](19);

                console.error(_context3.t1);

                Notiflix.Notify.failure("Une erreur est survenue sur l'object :" + customerCommunication._id);

              case 70:
                _iteratorNormalCompletion5 = true;
                _context3.next = 15;
                break;

              case 73:
                _context3.next = 79;
                break;

              case 75:
                _context3.prev = 75;
                _context3.t2 = _context3["catch"](13);
                _didIteratorError5 = true;
                _iteratorError5 = _context3.t2;

              case 79:
                _context3.prev = 79;
                _context3.prev = 80;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 82:
                _context3.prev = 82;

                if (!_didIteratorError5) {
                  _context3.next = 85;
                  break;
                }

                throw _iteratorError5;

              case 85:
                return _context3.finish(82);

              case 86:
                return _context3.finish(79);

              case 87:
                _context3.next = 89;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 89:
                customer = _context3.sent;
                _context3.next = 92;
                return ElearningCampaignsService.find({
                  filter: {
                    where: {
                      customerId: "$" + customer._id,
                      type: { $in: ["short", "challenge"] },
                      startDate: { $gte: vm.from, $lte: vm.to } // startDate must be in elearningCampaign.json
                    },
                    fields: {
                      _id: true,
                      name: true,
                      type: true,
                      elearningTemplateIds: true,
                      lastGenerationDate: true,
                      startDate: true,
                      creationDate: true
                    }
                  }
                });

              case 92:
                campaigns = _context3.sent;
                _context3.next = 95;
                return CustomListsService.getNameByValue("typeCustomerCommunication", "2");

              case 95:
                rowTypeShort = _context3.sent;
                _context3.next = 98;
                return CustomListsService.getNameByValue("typeCustomerCommunication", "13");

              case 98:
                rowTypeChallenge = _context3.sent;
                _context3.next = 101;
                return CustomListsService.getNameByValue("typeCommunicationWay", "11");

              case 101:
                rowWay = _context3.sent;
                _context3.next = 104;
                return ElearningTemplatesService.find({
                  filter: {
                    where: { type: { $in: ["short", "challenge"] } },
                    fields: {
                      _id: true,
                      name: true,
                      portraitPosterPath: true,
                      landscapePosterPath: true,
                      keywords: true,
                      vehicleType: true
                    }
                  }
                });

              case 104:
                templates = _context3.sent;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context3.prev = 108;
                _iterator6 = campaigns[Symbol.iterator]();

              case 110:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context3.next = 148;
                  break;
                }

                campaign = _step6.value;

                if (campaign.lastGenerationDate) {
                  _context3.next = 114;
                  break;
                }

                return _context3.abrupt("continue", 145);

              case 114:

                campaign.templateNames = [];
                campaign.templateLandscapeLinks = [];
                campaign.portraitPosterLinks = [];
                campaign.landscapePosterLinks = [];
                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context3.prev = 121;
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                  var templateId, template, _keywordsNames, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _keyword, _keywordName;

                  return regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          templateId = _step8.value;
                          template = templates.find(function (template) {
                            return template._id === templateId;
                          });

                          if (!template) {
                            _context2.next = 37;
                            break;
                          }

                          campaign.templateNames.push((template.vehicleType ? template.vehicleType : "???") + " - " + template.name);
                          if (template.portraitPosterPath) {
                            campaign.portraitPosterLinks.push(template.portraitPosterPath);
                          }
                          if (template.landscapePosterPath) {
                            campaign.landscapePosterLinks.push(template.landscapePosterPath);
                          }
                          _keywordsNames = [];

                          if (!template.keywords) {
                            _context2.next = 36;
                            break;
                          }

                          _iteratorNormalCompletion9 = true;
                          _didIteratorError9 = false;
                          _iteratorError9 = undefined;
                          _context2.prev = 11;
                          _iterator9 = template.keywords[Symbol.iterator]();

                        case 13:
                          if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                            _context2.next = 22;
                            break;
                          }

                          _keyword = _step9.value;
                          _context2.next = 17;
                          return CustomListsService.getNameByValue("keywords", _keyword);

                        case 17:
                          _keywordName = _context2.sent;

                          _keywordsNames.push("#" + _keywordName);

                        case 19:
                          _iteratorNormalCompletion9 = true;
                          _context2.next = 13;
                          break;

                        case 22:
                          _context2.next = 28;
                          break;

                        case 24:
                          _context2.prev = 24;
                          _context2.t0 = _context2["catch"](11);
                          _didIteratorError9 = true;
                          _iteratorError9 = _context2.t0;

                        case 28:
                          _context2.prev = 28;
                          _context2.prev = 29;

                          if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                          }

                        case 31:
                          _context2.prev = 31;

                          if (!_didIteratorError9) {
                            _context2.next = 34;
                            break;
                          }

                          throw _iteratorError9;

                        case 34:
                          return _context2.finish(31);

                        case 35:
                          return _context2.finish(28);

                        case 36:
                          campaign.keywordsNames = _keywordsNames;

                        case 37:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop, _this, [[11, 24, 28, 36], [29,, 31, 35]]);
                });
                _iterator8 = campaign.elearningTemplateIds[Symbol.iterator]();

              case 124:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  _context3.next = 129;
                  break;
                }

                return _context3.delegateYield(_loop(), "t3", 126);

              case 126:
                _iteratorNormalCompletion8 = true;
                _context3.next = 124;
                break;

              case 129:
                _context3.next = 135;
                break;

              case 131:
                _context3.prev = 131;
                _context3.t4 = _context3["catch"](121);
                _didIteratorError8 = true;
                _iteratorError8 = _context3.t4;

              case 135:
                _context3.prev = 135;
                _context3.prev = 136;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 138:
                _context3.prev = 138;

                if (!_didIteratorError8) {
                  _context3.next = 141;
                  break;
                }

                throw _iteratorError8;

              case 141:
                return _context3.finish(138);

              case 142:
                return _context3.finish(135);

              case 143:
                row = {
                  typeName: campaign.type === "short" ? rowTypeShort : rowTypeChallenge,
                  wayName: rowWay,
                  communicationDate: campaign.startDate,
                  keywordsNames: campaign.keywordsNames,
                  landscapeLinks: campaign.templateLandscapeLinks,
                  portraitPosterLinks: campaign.portraitPosterLinks,
                  landscapePosterLinks: campaign.landscapePosterLinks,
                  note: campaign.name,
                  creationDate: campaign.creationDate,
                  campaignId: campaign._id,
                  elearningTemplateIds: campaign.elearningTemplateIds,
                  btOpenVideoLink: {
                    text: '<i class="fa fa-eye"></i> Voir',
                    color: "custom"
                  },
                  btOpenVideoLandscapeLink: {
                    text: '<i class="fa fa-eye"></i> Voir (paysage)',
                    color: "custom"
                  },
                  btOpenPortraitLink: campaign.portraitPosterLinks && campaign.portraitPosterLinks.length > 0 ? {
                    text: '<i class="fa fa-download"></i> Télécharger',
                    color: "custom"
                  } : null,
                  btOpenLandscapeLink: campaign.landscapePosterLinks && campaign.landscapePosterLinks.length > 0 ? {
                    text: '<i class="fa fa-download"></i> Télécharger',
                    color: "custom"
                  } : null,
                  btFollowCampaign: new Date(campaign.startDate) > new Date() ? null : {
                    text: '<i class="fa fa-pie-chart"></i> Suivre',
                    color: "custom-dark"
                  }
                };

                vm.rawData.push(row);

              case 145:
                _iteratorNormalCompletion6 = true;
                _context3.next = 110;
                break;

              case 148:
                _context3.next = 154;
                break;

              case 150:
                _context3.prev = 150;
                _context3.t5 = _context3["catch"](108);
                _didIteratorError6 = true;
                _iteratorError6 = _context3.t5;

              case 154:
                _context3.prev = 154;
                _context3.prev = 155;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 157:
                _context3.prev = 157;

                if (!_didIteratorError6) {
                  _context3.next = 160;
                  break;
                }

                throw _iteratorError6;

              case 160:
                return _context3.finish(157);

              case 161:
                return _context3.finish(154);

              case 162:

                vm.rawData.sort(function (a, b) {
                  return moment(b.communicationDate).isBefore(moment(a.communicationDate)) ? -1 : 1;
                });

                Notiflix.Loading.remove();

                $timeout(function () {
                  _this.needToBeUpdate = true;
                });
                _context3.next = 172;
                break;

              case 167:
                _context3.prev = 167;
                _context3.t6 = _context3["catch"](1);

                Notiflix.Notify.failure("Une erreur est survenue au chargement des données");

                console.error(_context3.t6);
                Notiflix.Loading.remove();

              case 172:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, _this, [[1, 167], [13, 75, 79, 87], [19, 66], [35, 48, 52, 60], [53,, 55, 59], [80,, 82, 86], [108, 150, 154, 162], [121, 131, 135, 143], [136,, 138, 142], [155,, 157, 161]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var displayCreateBt = isSuper || vm.isAdmin;
    var displayEditBt = isSuper || vm.isAdmin;
    var displayDeleteBt = isSuper;

    if (displayCreateBt !== true) {
      vm.create = null;
    }

    vm.delete = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var deleteCommunication;
        return regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return swal({
                  title: "Voulez-vous supprimer la communication " + row.typeName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteCommunication = _context4.sent;

                if (!deleteCommunication) {
                  _context4.next = 7;
                  break;
                }

                console.log("need to delete this communication", row);
                _context4.next = 7;
                return CustomerCommunicationsService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    vm.columnDefs = [AgGridService.button("btOpenVideoLink", "Ouvrir le(s) lien(s)", vm.openVideoLink, this, {
      width: 70
    }), AgGridService.button("btOpenPortraitLink", "Affiche(s) poster", vm.openPortraitLink, this, {
      width: 110
    }), AgGridService.button("btOpenLandscapeLink", "Affiche(s) paysage", vm.openLandscapeLink, this, {
      width: 110
    }), AgGridService.text("typeName", "Quoi"), AgGridService.text("wayName", "Comment"), AgGridService.date("communicationDate", "Date de la communication"), AgGridService.text("keywordsNames", "Mots-clés"), AgGridService.text("note", "Commentaires"), AgGridService.number("nbDocs", "Docs")];

    if (displayEditBt || displayDeleteBt) {
      var adminColumns = [];

      if (displayEditBt) {
        adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, this, {
          width: 90
        }));
      }
      if (displayDeleteBt && displayEditBt) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 90,
          columnGroupShow: "open"
        }));
      } else if (displayDeleteBt) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 90
        }));
      }
      var adminGroup = AgGridService.group("Admin", adminColumns);
      vm.columnDefs.unshift(adminGroup);
    }
    vm.refresh();
  }
})();